import React from 'react'
import { useSelector } from 'react-redux'
import LoginLoadingView from '../view/LoginLoadingView'

export default function AppGate ({ children }) {
  const isFetchingUserData = useSelector(state => state.auth.isFetching)
  const isLogged = useSelector(state => state.auth.isLogged)
  const isLoading = isLogged && isFetchingUserData

  return (
    <>
      {isLoading && <LoginLoadingView />}
      {!isLoading && children}
    </>
  )
}
